import React from "react";

const AnimatedCross = ({crossColor="#fff", backgroundColor="#dc3545", style={}, animation=true}) => {
  return (
    <svg style={style} id={animation ? "crossmark" : "without-animation"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
      <circle cx="26" cy="26" r="25" fill={backgroundColor} />
      <path
        fill="none"
        stroke={crossColor}
        strokeWidth="5"
        d="M17 17 L35 35 M35 17 L17 35"
      />
    </svg>
  );
};

export default AnimatedCross;